import { MoviePoster } from './movie-poster';

export const MovieCatalogCategories = {
  comingSoon: 'coming-soon',
  events: 'events',
  foreign: 'foreign',
  nowPlaying: 'now-playing',
} as const;

export const MovieCatalogSorts = {
  alphabetical: 'alphabetical',
  popular: 'popular',
  releaseDate: 'release-date',
} as const;

export type MovieCatalogCategory = typeof MovieCatalogCategories[keyof typeof MovieCatalogCategories];

type MovieCatalogSort = typeof MovieCatalogSorts[keyof typeof MovieCatalogSorts];

export type MovieCatalogLocation = {
  latitude?: number;
  longitude?: number;
  preserveCategoryMembership?: boolean;
  zipCode?: string;
};

export type MovieCatalogFilters = {
  formats: string[];
  genres: string[];
  languages: string[];
  ratings: string[];
  sort: MovieCatalogSort;
};

export type MovieCatalogRequest = {
  businessDate?: Date;
  category: MovieCatalogCategory;
  filters: MovieCatalogFilters;
  location: MovieCatalogLocation;
};

export type MovieCatalogItem = MoviePoster & {
  genre?: string;
};

export type MovieCatalogItemResponse = {
  advanceTicketsEndDate?: Date;
  advanceTicketsStartDate?: Date;
  availableFormats: string[];
  category: MovieCatalogCategory;
  cinemarkMovieId: number;
  genres: string[];
  languages: string[];
  movieId: number;
  movieTitle: string;
  posterAltText: string;
  posterLargeImage?: { url?: string; };
  posterMediumImage?: { url?: string; };
  posterSmallImage?: { url?: string; };
  publicOnSaleDate?: Date;
  rating: string;
  releaseDate?: Date;
  runningTime?: number;
  slug: string;
  trailerUrl?: string;
};

export type MovieCatalogResponse = {
  appliedFilters: MovieCatalogFilters;
  availableFilterOptions: {
    formats: { displayName: string; value: string; }[];
    genres: { displayName: string; value: string; }[];
    languages: { displayName: string; value: string; }[];
    ratings: { displayName: string; value: string; }[];
  };
  hasMovies: boolean;
  location: {
    displayLabel: string;
    nearbyTheaters: {
      city?: string;
      state?: string;
      theaterId: number;
      theaterName?: string;
      zipCode?: string;
    }[];
    zipCode?: string;
  };
  movies: MovieCatalogItemResponse[];
};
